var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 17.375V15.625C13.625 14.6967 13.2563 13.8065 12.5999 13.1501C11.9435 12.4937 11.0533 12.125 10.125 12.125H4.875C3.94674 12.125 3.0565 12.4937 2.40013 13.1501C1.74375 13.8065 1.375 14.6967 1.375 15.625V17.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.625C9.433 8.625 11 7.058 11 5.125C11 3.192 9.433 1.625 7.5 1.625C5.567 1.625 4 3.192 4 5.125C4 7.058 5.567 8.625 7.5 8.625Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.56b6f47ac41da0fbc5758fa86f8d5ea3.svg";
export { ForwardRef as ReactComponent };